import { render, staticRenderFns } from "./delivery-list.vue?vue&type=template&id=c3bfb3f0&scoped=true"
import script from "./delivery-list.vue?vue&type=script&lang=js"
export * from "./delivery-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bfb3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3bfb3f0')) {
      api.createRecord('c3bfb3f0', component.options)
    } else {
      api.reload('c3bfb3f0', component.options)
    }
    module.hot.accept("./delivery-list.vue?vue&type=template&id=c3bfb3f0&scoped=true", function () {
      api.rerender('c3bfb3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/delivery-list/delivery-list.vue"
export default component.exports